import { createSelector } from 'reselect';

import { Wallpaper } from '../action/helper/image';
import {
  INACTIVE_SUBSCRIPTION_STATUS,
  State,
  SUBSCRIPTION_STATUS,
} from '../types';

export const accountSelector = (state: State): State['account'] =>
  state.account;

export const selectAccountWallpapers = createSelector(
  accountSelector,
  (account: State['account']): Wallpaper[] => account.wallpapers
);

export const selectAccountHasActiveSubsciption = createSelector(
  accountSelector,
  (account) => account.active_subscription
);

export const selectAccountWallpaperLink = createSelector(
  accountSelector,
  (account) => account.wallpaper_link
);

export const selectAccountTitle = createSelector(
  accountSelector,
  (account) => account.title
);

export const selectAccountId = createSelector(
  accountSelector,
  (account) => account.id
);

export const selectOrderCountryCode = createSelector(
  accountSelector,
  (account) => account.subscription?.order?.country_code
);

export const selectAccountSubscription = createSelector(
  accountSelector,
  (account) => account.subscription
);

export const selectAccountSubscriptionId = createSelector(
  selectAccountSubscription,
  (accountSubscription) => {
    const { id } = accountSubscription;

    return id;
  }
);

export const selectAccountSubscriptionsQuantity = createSelector(
  selectAccountSubscription,
  (accountSubscription) => {
    const { quantity } = accountSubscription;

    return quantity;
  }
);

export const selectUserCanCancelSubscription = createSelector(
  selectAccountSubscription,
  (accountSubscription) => {
    const { status, cancel_at_period_end } = accountSubscription;

    return (
      !INACTIVE_SUBSCRIPTION_STATUS.includes(status) && !cancel_at_period_end
    );
  }
);

export const selectUserCanReactivateSubscription = createSelector(
  selectAccountSubscription,
  (accountSubscription) => {
    const { cancel_at_period_end } = accountSubscription;

    return SUBSCRIPTION_STATUS.active && cancel_at_period_end;
  }
);
